import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ContextService } from '../../services/context/context.service';
import { DataService } from '../../services/context/data.service';
import { UIStateService } from '../../services/context/uistate.service';
import { AccountsService } from '../../services/accounts.service';
import { AppMonitoringService } from '../../services/util/app-monitoring.service';
import * as fromModel from '../../services/models';
import { MatDialog } from '@angular/material/dialog';
import { EditClientComponent } from '../edit-client/edit-client.component';
import { RefDataService } from '../../services/context/ref-data.service';
import { DeleteConfirmationComponent } from '../../context-components/delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'gp-client-summary',
  templateUrl: './client-summary.component.html',
  styleUrls: ['./client-summary.component.scss']
})
export class ClientSummaryComponent implements OnInit, OnDestroy {

  @Input('ClientId') clientid: string;
  @Input('AllowToChange') allowToChange = true;

  protected _storeDataSubscription: Subscription;
  client: any;
  
  

  constructor(private accountsService: AccountsService,
    private contextService:ContextService,
    private refDataService: RefDataService,
    private dataService:DataService,
    private uiStateService: UIStateService,
    private dialog: MatDialog,
    private appMonitoringService: AppMonitoringService) {      
    }

  ngOnInit(): void {
    this._storeDataSubscription = this.dataService.subscribe((appData: fromModel.IAppData) => this.populateAppData(appData));   
  }

  private populateAppData(appData: fromModel.IAppData){
    if(appData && appData.action!==fromModel.DATA_ACTION.NONE){
      if(this.clientid){
        this.client = this.dataService.getPlanClientByClientId(this.clientid); //check if client is in PlanClinets if not go to Clients collection
        if(!this.client){
          this.client = this.dataService.getClientByClientId(this.clientid);
        }
      }
    }
  }

  // getTaxStatusColor(taxStatus): string{   
  //   return this.refDataService.getPlanningUIRefDataByTypeCode(fromModel.PLANNINGUIREFTYPE.Colors,taxStatus.replace('-','').toUpperCase()).value;
  // }


  editClient(){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.EDITCLIENT, this.client.role, this.client.clientid);
  }

  removeClient(){
    this.openModelDialog(fromModel.OPENDIALOGACTIONS.REMOVECLIENT,this.client.clientid,this.client.clientname);    
  }

  openModelDialog(action: fromModel.OPENDIALOGACTIONS, parm1?: string, parm2?: string){
    switch(action){
      case fromModel.OPENDIALOGACTIONS.EDITCLIENT: {
        const dialogRef = this.dialog.open(EditClientComponent, {
          width: '35%',
          height: '55%',
          data: {mode: 'edit', role: parm1, clientid: parm2},          
          disableClose: true    
          }).afterClosed()
          .subscribe(result => {            
          });        
        break;
      }  
      case fromModel.OPENDIALOGACTIONS.REMOVECLIENT: {
        const dialogRef = this.dialog.open(DeleteConfirmationComponent, {
          width: '500px',
          height: '290px',
          data: { deleteType: fromModel.DELETETYPE.Client, name: parm2}                  
        }).afterClosed()
        .subscribe(isDeleted => {
          if(isDeleted){
            // let inc = this.dataService.getIncomeByIncomeId(parm1);
            // //let goal = this.dataService.getGoalByExpenseId(incomeId);
            // this.dataService.dispatchAction(fromModel.DATA_ACTION.DELETEINCOME, "IncomeListComponent-openModelDialog-deleteIncome", {income: inc});
            // this.dataService.savePlan();
            // this.UpdateIncome.emit();    
            //this.dataService.dispatchAction(fromModel.DATA_ACTION.SELECTEDPLANCLIENT, "ClientSummaryComponent-removeClient", {clientid: parm1});     
            //this.dataService.savePlan();
            this.dataService.removeClient(parm1);                      
          }
        });
        break;
      }    
    }
  }

  ngOnDestroy(): void{
    if(this._storeDataSubscription && this._storeDataSubscription !== null){
      this._storeDataSubscription.unsubscribe();
    }        
  }
}
